const DEFAULTS = {
    apiEndpoint: 'https://www.templatefarm.io/api',
    imageApiEndpoint: 'https://imageapi.templatefarm.io',
    apiKey: null,
    template: null
}

window.TE = {
    mount: (selector, options) => {
        const root = document.querySelector(selector);
        const editor = document.createElement('te-designer');
        editor.options = Object.assign({}, DEFAULTS, options);
        editor.apiKey = editor.options?.apiKey;
        editor.template = editor.options?.template;
        root.appendChild(editor);
    },
    popup: (options, callback) => {
        const root = document.body;
        const editor = document.createElement('te-designer-popup');
        editor.options = Object.assign({}, DEFAULTS, options);
        editor.apiKey = editor.options?.apiKey;
        editor.template = editor.options?.template;
        editor.callback = callback;
        root.appendChild(editor);
    }
}
